import React from 'react'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import PrepaymentSF from '../../../components/superUser/loan/repayment/PrepaymentSF'
import LoanPropertyListSF from '../../../components/superUser/loan/util/LoanPropertyListSF'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import CardUI from '../../../widgets/layout/CardUI.js'
import { Link } from 'react-router-dom'
import RepaymentTestUpdateModalSF from './RepaymentTestUpdateModalSF.js'
// import './PrepaymentPage.css'

const PrepaymentPageUI = ({ context, errorList, account, loan, prepayment, repaymentGoodStanding, repaymentPencilClickMode,
  onRepaymentPencilClick, onRepaymentPencilCancelClick, onClearDataClick,
  repaymentClearDataClickMode, onRepaymentClearDataClick, onRepaymentClearDataCancelClick, onRefreshClick,
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_prep'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !account}
    loan={loan} page='prepayment'
  >
    {
      (!loan || !errorList || !account) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Prepayment</b></span>
            </span>
          }
          right={<span />}
        />

        {
          (loan.status === 'disbursed' || loan.subStatus === 'repaid' || loan.subStatus === 'prepaid' || loan.subStatus === 'defaulted') &&
          <PrepaymentSF
            context={context} account={account} loan={loan} onRefreshClick={onRefreshClick}
            prepayment={prepayment} repaymentGoodStanding={repaymentGoodStanding} />
        }
      </div>
    }
    {
      loan &&
      <LoanPropertyListSF context={context} loan={loan} category='prepayment' categoryLabel='Prepayment tokens' />
    }
    <CardUI className='g_m_top_100'>
      <div className='g_flex_h'>
        <span><b>Repayment Test</b></span>
        <div>
          <Link to='#' onClick={onRepaymentClearDataClick} style={{ marginRight: '10px' }}>Clear Test Data</Link>
          <Link to='#' onClick={onRepaymentPencilClick}>Add Test Data</Link>
        </div>
      </div>
    </CardUI>
    <RepaymentTestUpdateModalSF context={context} loan={loan}
      updateMode={repaymentPencilClickMode} onCancelClick={onRepaymentPencilCancelClick}
      clearDataMode={repaymentClearDataClickMode} onClearDataCancelClick={onRepaymentClearDataCancelClick}
      onRefreshClick={onRefreshClick} />
  </SuperUserLoanPageSF>

export default PrepaymentPageUI
